import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { class: "pagestyle" }

import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  import {useRouter} from 'vue-router'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

  const router = useRouter()
  const searchForm = reactive({
    status:"",
    words:"",
    limit:10,
    page:1,
  })
  const baseData = reactive({
    loading:false,
    title:'',
    userbox:false,
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const search = () => {
    searchForm.page = 1
    getList()
  }
  const reset = () => {
    searchForm.page = 1
    searchForm.words = ""
    searchForm.status = ""
    getList()
  }
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const getList = () => {
    baseData.loading = true
    api.supplierApi.list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        tableData.data = res.data.data
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const add = (data:any) => {
    router.push("/supplier/add");
  }
  const edit = (id:any) => {
    router.push("/supplier/edit/"+id);
  }
  const del = (id:number) => {
    baseData.loading = true
    api.supplierApi.del({id:id}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  onMounted(() => {
    getList()
  })
  
return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { shadow: "never" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_breadcrumb, {
            class: "breadcrumb",
            separator: "/"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
                default: _withCtx(() => [
                  _createTextVNode("工作台")
                ]),
                _: 1
              }),
              _createVNode(_component_el_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _createTextVNode("服务商列表")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "editbtn",
            onClick: add
          }, {
            default: _withCtx(() => [
              _createTextVNode("新增")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: searchForm,
          inline: "",
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: searchForm.status,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "全部",
                      value: ""
                    }),
                    _createVNode(_component_el_option, {
                      label: "待审核",
                      value: "1"
                    }),
                    _createVNode(_component_el_option, {
                      label: "通过审核",
                      value: "2"
                    }),
                    _createVNode(_component_el_option, {
                      label: "审核不通过",
                      value: "3"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "关键词" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: searchForm.words,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.words) = $event)),
                  placeholder: "公司 | 联系人 | 手机号码"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: search
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("搜索")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, { onClick: reset }, {
                  default: _withCtx(() => [
                    _createTextVNode("重置")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"20px"}
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          "row-key": "id",
          border: "",
          data: tableData.data,
          style: {"width":"100%","margin-top":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "ID",
              width: "60"
            }),
            _createVNode(_component_el_table_column, {
              prop: "company",
              label: "公司名"
            }),
            _createVNode(_component_el_table_column, { label: "基础资料" }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", null, "联系人：" + _toDisplayString(scope.row.name), 1),
                _createElementVNode("div", null, "手机号码：" + _toDisplayString(scope.row.mobile), 1),
                _createElementVNode("div", null, "邮箱：" + _toDisplayString(scope.row.email), 1),
                _createElementVNode("div", null, "地址：" + _toDisplayString(scope.row.address), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "服务地区",
              width: "200"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("p", null, _toDisplayString(scope.row.province) + " - " + _toDisplayString(scope.row.city) + " - " + _toDisplayString(scope.row.area), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "loginTime",
              label: "登录时间",
              width: "160"
            }),
            _createVNode(_component_el_table_column, {
              prop: "ip",
              label: "登录IP",
              width: "140"
            }),
            _createVNode(_component_el_table_column, {
              label: "状态",
              width: "100"
            }, {
              default: _withCtx((scope) => [
                (scope.row.status == 1)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_2, "待审核"))
                  : (scope.row.status == 2)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, "审核通过"))
                    : (scope.row.status == 3)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_4, "审核不通过"))
                      : (_openBlock(), _createElementBlock("p", _hoisted_5, "冻结"))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              label: "操作",
              width: "220"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: ($event: any) => (edit(scope.row.id)),
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("编辑")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: ($event: any) => (del(scope.row.id)),
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, baseData.loading]
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_pagination, {
            "current-page": searchForm.page,
            "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((searchForm.page) = $event)),
            "page-size": searchForm.limit,
            "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((searchForm.limit) = $event)),
            layout: "sizes, prev, pager, next",
            total: tableData.total,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total"])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})